import { createSelector } from '@ngrx/store'

export const getSettingsState = createSelector(
  (state: any) => state.settings,
  (state: any) => state,
)

export const getSecuritySettingsState = createSelector(
  (state: any) => state.settings,
  (state: any) => state.getIn(['data', 'security'])?.toJS(),
)
